import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueTippy from "vue-tippy";
import "tippy.js/themes/light.css";
import vuescroll from 'vuescroll';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
import AsyncComputed from 'vue-async-computed';
import VueEditableGrid from 'vue-editable-grid';
import 'vue-editable-grid/dist/VueEditableGrid.css'

// configure language
locale.use(lang)
Vue.use(AsyncComputed);
Vue.component('vue-editable-grid', VueEditableGrid);
Vue.use(VueTippy, {
    directive: "tippy", // => v-tippy
    theme: 'light',
    placement: 'right',
    arrow: true,
    // interactive: true,
    animation: 'scale',
    popperOptions: {
        modifiers: {
            preventOverflow: {
                enabled: false
            },
            hide: {
                enabled: false,
            }
        }
    }
});
Vue.use(vuescroll, {
    ops: {
        bar: { background: 'rgba(0,0,0,0.4)', }
    },
});
Vue.config.productionTip = false

export const bus = new Vue({});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
